export default function rooms(gsap, ScrollTrigger){

const navLinks = document.querySelectorAll('.site-rooms .localnav a')
const roomItems = document.querySelectorAll('.site-rooms .localroom__item')

navLinks.forEach(link => {
  link.addEventListener('click', e => {
    e.preventDefault()

    const category = link.dataset.category

    // アクティブ切り替え
    navLinks.forEach(a => a.classList.remove('is-active'))
    link.classList.add('is-active')

    roomItems.forEach(item => {

      // 「すべて」
      if (category === 'all') {
        item.classList.remove('is-hidden')
        return
      }

      const match = [...item.querySelectorAll('.category li')]
        .some(li => li.textContent.trim() === category)

      item.classList.toggle('is-hidden', !match)
    })
  })
})

}